import { Trans, useTranslation } from 'react-i18next';

import { ResendEmailVerificationLinkForm } from 'authOld/components';
import { SignInSteps } from 'authOld/constants';
import { IAuthUserForm } from 'authOld/types';
import { Field, Form } from 'coreOld/components';
import { HeaderModalOptions } from 'coreOld/constants';
import { LinkText } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';

import { signInFormSchema } from './signInFormSchema';
import { FooterText, FooterWrapper } from './signInFormStyle';

interface IProps {
  openedAuthModal: HeaderModalOptions;
  openAuthModal: (type: HeaderModalOptions) => void;
  onClose: () => void;
  step: SignInSteps;
  onSubmit: () => (data: IAuthUserForm) => void;
  goBack: () => void;
  email?: string;
}

const SignInFormView = ({
  openedAuthModal,
  openAuthModal,
  onClose,
  step,
  onSubmit,
  goBack,
  email = '',
}: IProps) => {
  const { t } = useTranslation();

  const footerContent = (
    <FooterWrapper>
      <FooterText>
        <Trans
          i18nKey="messageSignUp"
          components={[
            <LinkText onClick={() => openAuthModal(HeaderModalOptions.SIGN_UP)} key="signUp" />,
          ]}
        />
      </FooterText>
      <FooterText>
        <LinkText onClick={() => openAuthModal(HeaderModalOptions.RESEND_EMAIL_VERIFICATION_LINK)}>
          {t('messageResendEmail')}
        </LinkText>
        <br />
        <LinkText onClick={() => openAuthModal(HeaderModalOptions.FORGOT_PASSWORD)}>
          {t('messageForgotPassword')}
        </LinkText>
      </FooterText>
    </FooterWrapper>
  );

  return (
    <>
      <Form<IAuthUserForm>
        isOpen={openedAuthModal === HeaderModalOptions.SIGN_IN}
        onClose={onClose}
        title={t('labelSignIn')}
        submitBtnLabel={
          step === SignInSteps.PASSWORD ? t('buttonLabelSignIn') : t('buttonLabelContinue')
        }
        defaultValues={{ email: email, password: '' }}
        onSubmit={onSubmit}
        schema={signInFormSchema(step === SignInSteps.PASSWORD)}
        footerContent={footerContent}
        hasGoBack={step === SignInSteps.PASSWORD}
        goBack={goBack}
      >
        <Field
          name="email"
          label={t('labelEmailAddress')}
          type={InputType.TEXTFIELD}
          inputProps={{
            size: Size.LG,
            disabled: step === SignInSteps.PASSWORD,
            editable: step === SignInSteps.EMAIL,
            autoFocus: step === SignInSteps.EMAIL,
          }}
          wrapperStyle={{ fontSize: 12 }}
        />

        <Field
          name="password"
          label={t('labelPassword')}
          type={InputType.PASSWORD}
          hidden={step !== SignInSteps.PASSWORD}
          inputProps={{
            size: Size.LG,
            autoFocus: step === SignInSteps.PASSWORD,
          }}
        />
      </Form>

      <ResendEmailVerificationLinkForm
        isOpen={openedAuthModal === HeaderModalOptions.RESEND_EMAIL_VERIFICATION_LINK}
        onClose={onClose}
        goBack={() => openAuthModal(HeaderModalOptions.SIGN_IN)}
      />
    </>
  );
};

export default SignInFormView;
